// extracted by mini-css-extract-plugin
export var label = "index-module--label--PLO3i";
export var link = "index-module--link--A1bYi";